import {useRef} from 'react';

export function useLatest<T = any>(state: T) {
  const ref = useRef<T>(state);
  ref.current = state;
  return ref;
}
